import React from 'react';
import { Link } from 'react-router-dom';
import { Popconfirm } from 'antd';
import { DeleteOutlined, MenuOutlined } from '@ant-design/icons';
import { sortableHandle } from 'react-sortable-hoc';

import { webCardDelete } from '../../redux/actions/webCards';

const DragHandle = sortableHandle(() => (
  <MenuOutlined className="drag-handle" />
));

export const webCardColumns = (dispatch) => [
  {
    title: '',
    dataIndex: 'sort',
    width: 30,
    className: 'drag-visible',
    render: () => <DragHandle />,
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 35,
    className: 'drag-visible',
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    className: 'drag-visible',
  },
  {
    title: 'CTA Label',
    dataIndex: 'ctaLabel',
    key: 'ctaLabel',
  },
  {
    title: 'Order',
    dataIndex: 'order',
    key: 'order',
  },
  {
    title: 'Actions',
    width: 100,
    render: (_, { id }) => (
      <>
        <Link to={`/cards/edit/${id}`}><span className="web-cards__edit-button">Edit</span></Link>
        <Popconfirm
          title="Are you sure to delete this item?"
          onConfirm={() => dispatch(webCardDelete(id))}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined style={{ fontSize: 18 }} />
        </Popconfirm>
      </>
    ),
  },
];
